import { useEffect } from "react";

import { handleBackgroundError } from "~/utils/handleError";

export const useBackgroundError = (error: unknown): void => {
  useEffect(() => {
    if (error) {
      handleBackgroundError(error);
    }
  }, [error]);
};
